import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/templates/code.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Call to action`}</h1>
    <p>{`This pattern is used for call to action links to allows user to navigate around the site.`}</p>
    <h4>{`Primary`}</h4>
    <p>{`Primary buttons are used for highlighting important actions within a page or workflow. Use Primary sparingly, as overuse can cause confusion to a user.`}</p>
    <pre><code parentName="pre" {...{}}>{`<CTA>Primary</CTA>
`}</code></pre>
    <h4>{`Secondary`}</h4>
    <p>{`Secondary is intended for general use buttons and actions like triggering popouts, filtering and sharing actions. This is typically the most appropriate button type because of its neutral visual weight.`}</p>
    <pre><code parentName="pre" {...{}}>{`<CTA type="secondary">Secondary</CTA>
`}</code></pre>
    <h4>{`Text link`}</h4>
    <p>{`Under the hood, Link is an extension of the Text component. By default it will inherit its font size from its parent unless a size is set with the fontSize prop.`}</p>
    <pre><code parentName="pre" {...{}}>{`<CTA type="link">Text link</CTA>
`}</code></pre>
    <h4>{`Properties`}</h4>
    <p>{`System props apply standard sets of properties to a component that can be used to alter its appearance on the fly.`}</p>
    <PropsTable name="CTA" mdxType="PropsTable" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      